<template>
	<div class="Case">
		<div class="banner">
			<div class="content">
				<div class="content_2">
					<div class="banner_img">
						<img src="../assets/Case.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="pb40">
			<div class="content">
				<!-- <div class="content_2"> -->
					<el-row :gutter="30">
						<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(item, i) in caseList" :key="i">
							<div class="Case_item tran3" @click="look(item)">
								<div class="img mb20">
									<el-image style="width: 100%; height: 250px" :src="item.img" :fit="'cover'"></el-image>
								</div>
								<div class="Case_info">
									<div class="c3 f16 hang1 Case_title b bred">{{item.title}}</div>
									<div class="c6 f14 hang2 mb40">{{item.descr}}</div>
									<div>
										<div class="fl">{{item.date}}</div>
										<div class="fr bred"><i class="el-icon-plus"></i> 详情</div>
										<div class="cl"></div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				<!-- </div> -->
			</div>
		</div>
		<div class="hz bimg" id="hz">
			<div class="content">
				<div class="content_2">
					<div class="banner_title ls2" style="padding-top: 0!important;">合作伙伴</div>
					<div class="banner_title_e ls2">OUR CLIENTS</div>
					<div class="mt40">
						<el-row :gutter="20">
							<el-col :xs="8" :sm="6" :md="4" :lg="3" :xl="3" v-for="x in hzList" :key="x">
								<div class="hz_item zzz">
									<img class="tran3" :src="x" />
								</div>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="" v-model="show" destroy-on-close width="1200px" :show-close="false"
			:close-on-click-modal="true" @open="$opened(this)">
			<div class="Case_window">
				<div class="tz borb1">
					<div class="f30 b c3">{{dialog.title}}</div>
					<div class="f14 c9 ptb20">发布日期： {{dialog.date}}</div>
				</div>
				<div class="img tz mt20">
					<img :src="dialog.img" style="max-width: 80%;" />
				</div>
				<div class="tz ptb20 f18">{{dialog.descr}}</div>
				<div class="Case_window_content" v-html="dialog.html"></div>
				<div class="Case_close bluebg" @click="show = false">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				caseList: [],
				show: false,
				dialog: {},
				hzList: [
					require('../assets/hz_1.jpg'),
					require('../assets/hz_2.jpg'),
					require('../assets/hz_3.jpg'),
					require('../assets/hz_4.jpg'),
					require('../assets/hz_36.jpg'),
					require('../assets/hz_37.png'),
					require('../assets/hz_5.jpg'),
					require('../assets/hz_6.jpg'),
					require('../assets/hz_7.jpg'),
					require('../assets/hz_8.jpg'),
					require('../assets/hz_9.jpg'),
					require('../assets/hz_10.jpg'),
					require('../assets/hz_11.jpg'),
					require('../assets/hz_12.jpg'),
					require('../assets/hz_13.jpg'),
					require('../assets/hz_14.jpg'),
					require('../assets/hz_15.jpg'),
					require('../assets/hz_16.jpg'),
					require('../assets/hz_17.jpg'),
					require('../assets/hz_18.jpg'),
					require('../assets/hz_19.jpg'),
					require('../assets/hz_20.jpg'),
					require('../assets/hz_21.jpg'),
					require('../assets/hz_22.jpg'),
					require('../assets/hz_23.jpg'),
					require('../assets/hz_24.jpg'),
					require('../assets/hz_25.jpg'),
					require('../assets/hz_26.jpg'),
					require('../assets/hz_27.jpg'),
					require('../assets/hz_28.jpg'),
					require('../assets/hz_29.jpg'),
					require('../assets/hz_30.jpg'),
					require('../assets/hz_31.jpg'),
					require('../assets/hz_32.jpg'),
					require('../assets/hz_33.jpg'),
					require('../assets/hz_34.jpg'),
					require('../assets/hz_35.jpg'),
				]
			}
		},
		created() {
			this.caseList = this.$store.state.caseList;
			this.caseList.forEach((x,i) => {
				x.img = require(`@/assets/Case_${i+1}.jpg`)
			})
		},
		mounted() {
			
		},
		methods: {
			look(item) {
				this.show = true;
				this.dialog = item;
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';
	.Case {
		overflow: hidden;
		
		@media screen and (max-width: 768px) {
			.banner_title {
				font-size: 7vw;
			}
		}
		
		.banner {
			height: 360px;
			position: relative;
			background: url(../assets/Case.jpg) no-repeat center;
			margin-bottom: 75px;
			@media screen and (max-width: 768px) {
				height: 220px;
				background-size: cover;
				margin-bottom: 40px;
			}
		}

		.Case_item {
			padding: 24px;
			box-sizing: border-box;
			border-radius: 5px;
			margin-bottom: 30px;
			cursor: pointer;
			@media screen and (max-width: 768px) {
				margin-bottom: 4vw;
				padding: 4vw;
			}
			
			.hang2 {
				height: 56px;
				@media screen and (max-width: 768px) {
					margin-bottom: 4vw;
					height: auto;
				}
			}
		
			.Case_info {
				line-height: 2;
			}
		
			img {
				transition: all 0.3s;
				-webkit-transition: all 0.3s;
			}
		
			&:hover {
				box-shadow: 0 0 30px #d7d7d7;
		
				.bred {
					color: $blue;
				}
		
				img {
					transform: scale(1.05);
				}
				@media screen and (max-width: 768px) {
					box-shadow: none;
					img {
						transform: scale(1);
					}
				}
			}
		}
		
		.Case_window {
			padding: 10px 30px 50px;
			box-sizing: border-box;
			background: #FFFFFF;
			position: relative;
		}
		
		.Case_window_content {
			font-size: 16px;
			line-height: 2;
			
			p {
				margin-bottom: 20px;
				text-indent: 32px;
			}
			
			img {
				max-width: 770px;
				margin: 0 auto;
				display: block;
			}
			
			table {
				border-collapse: collapse;
				border-spacing: 0;
				// border-color: #E6E6E6;
				
				tr:first-of-type {
					background-color: #f2f2f2;
				}
				
				td {
					padding: 2px 8px;
				}
			}
		}
		
		.Case_close {
			position: absolute;
			width: 50px;
			height: 50px;
			right: -70px;
			top: -60px;
			text-align: center;
			cursor: pointer;
			i {
				font-size: 30px;
				color: #FFFFFF;
				line-height: 50px;
			}
		}

		.hz {
			background-image: url(../assets/hz.jpg);
			padding: 75px 0;

			.hz_item {
				height: 110px;
				margin-bottom: 20px;
				background-repeat: no-repeat;
				background-position: center;
				background-color: #fff;
				
				&:hover {
					img {
						transform: scale(1.05);
						-webkit-transform: scale(1.05);
					}
				}
			}
			
			.mt40 {
				@media screen and (max-width: 768px) {
					padding: 0 2vw;
					img {
						max-width: 90%;
					}
				}
			}
		}
	}
</style>
